import React from 'react';

import { FIELD_PATHS } from '@funnels/constants';
import { IncomeEntityIndex } from '@funnels/types';

import { StringDisplay, TextAreaField, TextInputField } from '../../Fields';
import { EditableViewProps, StringReadOnlyViewProps } from '../types';

interface IncomeDescriptionEditableViewProps extends EditableViewProps, IncomeEntityIndex {
  label?: string;
  disableFailMessage?: boolean;
  isSingleLine?: boolean;
}
export function IncomeDescriptionEditableView(props: IncomeDescriptionEditableViewProps) {
  const { label, incomeIndex, disableFailMessage, isSingleLine, isOptional, isDisabled } = props;

  if (isSingleLine) {
    return (
      <TextInputField
        name={FIELD_PATHS.INCOME_DESCRIPTION(incomeIndex)}
        label={label}
        validationFailMessage={'Please fill the description'}
        disableFailMessage={disableFailMessage}
        isOptional={isOptional}
        isDisabled={isDisabled}
        isFullWidth
      />
    );
  }

  return (
    <TextAreaField
      name={FIELD_PATHS.INCOME_DESCRIPTION(incomeIndex)}
      label={label}
      validationFailMessage={'Please fill the description'}
      isOptional={isOptional}
      isDisabled={isDisabled}
      isFullWidth
    />
  );
}
interface IncomeDescriptionFunnelViewProps extends IncomeEntityIndex {
  label?: string;
}
export const IncomeDescriptionFunnelView = (props: IncomeDescriptionFunnelViewProps) => {
  const { label = 'Description', incomeIndex, ...rest } = props;

  return (
    <TextInputField
      {...rest}
      name={FIELD_PATHS.INCOME_DESCRIPTION(incomeIndex)}
      label={label}
      validationFailMessage={'Please fill the description'}
      isFullWidth
    />
  );
};

export const IncomeDescriptionFunnelReadOnlyView = (props: StringReadOnlyViewProps) => <StringDisplay {...props} />;
